import { dew as _ListSpacesResponseDew } from "./ListSpacesResponse";
import { dew as _SpaceResponseDew } from "./SpaceResponse";
import { dew as _SpaceDew } from "./Space";
import { dew as _SpaceSizeDew } from "./SpaceSize";
import { dew as _SpaceConfigDew } from "./SpaceConfig";
import { dew as _InternalSpaceConfigBaseDew } from "./InternalSpaceConfigBase";
import { dew as _EventTokenResponseDew } from "./EventTokenResponse";
import { dew as _EventTokenDew } from "./EventToken";
import { dew as _GetSpacesSortFieldDew } from "./GetSpacesSortField";
import { dew as _SpaceAccessDew } from "./SpaceAccess";
var exports = {},
  _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  var __createBinding = exports && exports.__createBinding || (Object.create ? function (o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = {
        enumerable: true,
        get: function () {
          return m[k];
        }
      };
    }
    Object.defineProperty(o, k2, desc);
  } : function (o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
  });
  var __exportStar = exports && exports.__exportStar || function (m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
  };
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  __exportStar(_ListSpacesResponseDew(), exports);
  __exportStar(_SpaceResponseDew(), exports);
  __exportStar(_SpaceDew(), exports);
  __exportStar(_SpaceSizeDew(), exports);
  __exportStar(_SpaceConfigDew(), exports);
  __exportStar(_InternalSpaceConfigBaseDew(), exports);
  __exportStar(_EventTokenResponseDew(), exports);
  __exportStar(_EventTokenDew(), exports);
  __exportStar(_GetSpacesSortFieldDew(), exports);
  __exportStar(_SpaceAccessDew(), exports);
  return exports;
}